(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-order"] && !Shopify.designMode) return;
  try {
    
  const isHoverDevice = window.matchMedia('(hover: hover)').matches;

  for (const btn of document.querySelectorAll('.build-order-info-icon')) {
    const popoverId = btn.getAttribute('popovertarget');
    const popover = document.getElementById(popoverId);

    if (!popover) continue;

    if (!isHoverDevice) continue;

    btn.addEventListener('click', (e) => e.preventDefault());

    btn.addEventListener('mouseover', () => {
      const rect = btn.getBoundingClientRect();
      popover.style.bottom = `${window.innerHeight - rect.top + 8}px`;
      popover.style.left = `${rect.left + rect.width / 2}px`;
      popover.style.transform = 'translateX(-50%)';
      popover.showPopover();
    });

    btn.addEventListener('mouseout', () => popover.hidePopover());
  }

  for (const wrapper of document.querySelectorAll('.build-order-product-description-wrapper[data-has-toggle="true"]')) {
    const paragraph = wrapper.querySelector('.build-order-product-description');
    const toggle = wrapper.querySelector('.build-order-product-description-toggle');

    if (!paragraph || !toggle) continue;

    toggle.addEventListener('click', () => {
      const isExpanded = paragraph.classList.toggle('is-expanded');
      toggle.textContent = isExpanded ? 'Sluiten' : 'Lees meer';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
